export enum BillingPortalUrlType {
  default = 'None',
  paymentMethodUpdate = 'PaymentMethodUpdate',
  subscriptionCancel = 'SubscriptionCancel',
  subscriptionUpdate = 'SubscriptionUpdate',
  subscriptionConfirm = 'SubscriptionConfirm',
}
